<template>
  <div>
    <v-dialog v-model="showAddDialog" max-width="80%">
      <v-app>
        <v-form lazy-validation @submit.prevent="confirm">
          <v-card class="window-card">
            <v-card-title>
              <span class="md-title" style="color: #67ad5b"
                >新增角色元件动作</span
              >
            </v-card-title>
            <v-card-text>
              <div class="md-layout">
                <div class="md-layout-item md-size-100">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <v-text-field
                        v-model="form.name"
                        label="动作名称 *"
                        :rules="[(v) => !!v || '动作名称不能为空']"
                      ></v-text-field>
                    </div>
                  </div>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <v-select
                        v-model="form.template"
                        :items="template_list"
                        item-text="name"
                        item-value="value"
                        label="动作模板*"
                        :loading="templateLoading"
                        :rules="[(v) => !!v || '动作模板不能为空']"
                        @change="changeTemplate"
                      ></v-select>
                    </div>
                  </div>
                  <div
                    class="md-layout"
                    v-for="(item, index) in config"
                    :key="index"
                  >
                    <!-- 文本域 -->
                    <div
                      v-if="item.Type === 'TextField'"
                      class="md-layout-item md-size-100"
                    >
                      <v-text-field
                        v-model="form[item.Fields[0].Code]"
                        :type="item.Fields[0].InputType"
                        :label="item.Fields[0].Label"
                        :rules="[
                          item.Fields[0].FieldRequired
                            ? (v) => !!v || `${item.Fields[0].Label}不能为空`
                            : false,
                        ]"
                      ></v-text-field>
                    </div>
                    <!-- 多行文本框 -->
                    <div
                      v-if="item.Type === 'Textareas'"
                      class="md-layout-item md-size-100"
                    >
                      <v-textarea
                        v-model="form[item.Fields[0].Code]"
                        :label="item.Fields[0].Label"
                        auto-grow
                        :rules="[
                          item.Fields[0].FieldRequired
                            ? (v) => !!v || `${item.Fields[0].Label}不能为空`
                            : false,
                        ]"
                      ></v-textarea>
                    </div>
                    <!-- 下拉框 -->
                    <div
                      v-if="item.Type === 'Selects'"
                      class="md-layout-item md-size-100"
                    >
                      <v-select
                        v-model="form[item.Fields[0].Code]"
                        :items="item.Fields[0].Options"
                        item-text="name"
                        item-value="value"
                        :label="item.Fields[0].Label"
                        :rules="[
                          item.Fields[0].FieldRequired
                            ? (v) => !!v || `${item.Fields[0].Label}不能为空`
                            : false,
                        ]"
                      ></v-select>
                    </div>
                    <!-- 单选框 -->
                    <div
                      v-if="item.Type === 'Radio'"
                      class="md-layout-item md-size-100 d-flex align-center"
                    >
                      <span v-if="item.Fields[0].Label" class="text-md"
                        >{{ item.Fields[0].Label }}：</span
                      >
                      <v-radio-group
                        v-model="form[item.Fields[0].Code]"
                        :row="!item.Fields[0].isColumn"
                        :column="item.Fields[0].isColumn"
                        :mandatory="item.Fields[0].FieldRequired"
                      >
                        <v-radio
                          v-for="o in item.Fields[0].Options"
                          :key="o.value"
                          :label="o.name"
                          :value="o.value"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                    <!-- 开关 -->
                    <div
                      v-if="item.Type === 'Switches'"
                      class="md-layout-item md-size-100"
                    >
                      <v-switch
                        v-if="item.Type === 'Switches'"
                        v-model="form[item.Fields[0].Code]"
                        :label="item.Fields[0].Label"
                        color="red darken-3"
                        class="d-inline-flex"
                      ></v-switch>
                    </div>
                    <!-- 坐标系 -->
                    <div
                      v-if="item.Type === 'Zb'"
                      class="md-layout-item md-size-100"
                    >
                      <span v-if="item.Fields[0].Label" class="text-md"
                        >{{ item.Fields[0].Label }}：</span
                      >
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="form[item.Fields[0].XCode]"
                            label="X"
                            :rules="[
                              item.Fields[0].FieldRequired
                                ? (v) =>
                                    !!v || `${item.Fields[0].Label}X不能为空`
                                : false,
                            ]"
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="form[item.Fields[0].YCode]"
                            label="Y"
                            :rules="[
                              item.Fields[0].FieldRequired
                                ? (v) =>
                                    !!v || `${item.Fields[0].Label}Y不能为空`
                                : false,
                            ]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="form[item.Fields[0].ZCode]"
                            label="Z"
                            :rules="[
                              item.Fields[0].FieldRequired
                                ? (v) =>
                                    !!v || `${item.Fields[0].Label}Z不能为空`
                                : false,
                            ]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    <!-- 级联 -->
                    <div
                      v-if="item.Type === 'Cascader'"
                      class="md-layout-item md-size-100"
                    >
                      <v-row>
                        <v-col
                          v-for="(option, index2) in item.Fields"
                          :key="index2"
                          class="d-flex"
                          :cols="option.cols ? option.cols : '12'"
                        >
                          <v-select
                            v-if="option.Level === 1"
                            v-model="form[option.Code]"
                            :items="option.Options"
                            item-text="name"
                            item-value="value"
                            :label="option.Label"
                            :rules="[
                              option.FieldRequired
                                ? (v) => !!v || `${option.Label}不能为空`
                                : false,
                            ]"
                            @change="changeCascader(item, index2, $event)"
                          ></v-select>
                          <v-select
                            v-if="option.Level !== 1"
                            v-model="form[option.Code]"
                            :items="option.currOptions"
                            item-text="name"
                            item-value="value"
                            :label="option.Label"
                            :rules="[
                              option.FieldRequired
                                ? (v) => !!v || `${option.Label}不能为空`
                                : false,
                            ]"
                            @change="changeCascader(item, index2, $event)"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" type="submit">确定</v-btn>
              <v-btn color="success" @click="cancel">关闭</v-btn>
            </v-card-actions>
            <!-- <FormTemplate :Fields="Fields"  @getFormData='getFormData' ref="authForm"/> -->
          </v-card>
        </v-form>
      </v-app>
    </v-dialog>
  </div>
</template>
<script>
import { allListActionTemplate } from "@/api/common";
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, required_if } from "vee-validate/dist/rules";
import FormTemplate from "@/components/FormTemplate"; //引入自动生成表单模板

extend("required", required);
extend("required_if", required_if);
export default {
  props: {
    showAddDialog: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: -1,
    },
    formData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    SlideYDownTransition,
    FormTemplate,
  },
  watch: {
    formData(val) {
      this.form = val;
    },
  },
  data() {
    return {
      // 当前数据模板配置
      config: [],
      // 动作模板列
      template_list: [],
      // 动作模板列加载显示
      templateLoading: false,
      move_mod_list: [
        { value: "sy", name: "瞬移" },
        { value: "py", name: "平移" },
        { value: "xj", name: "寻径" },
      ],
      role_view_list: [
        { value: "first", name: "第一人称" },
        { value: "third", name: "第三人称" },
      ],
      lockview: "",
      form: {},
    };
  },
  mounted() {
    this.templateLoading = true;
    allListActionTemplate({
      template_type: "role",
    }).then((res) => {
      this.templateLoading = false;
      if (res.code === "200") {
        // actionList 返回的数据动作模板（未作处理的）
        this.actionList = res.data.rows;
        this.template_list = res.data.rows.map((item) => {
          return {
            value: item.template_code,
            name: item.name,
          };
        });
      }
    });
  },
  methods: {
    confirm() {
      //主动触发组件内验证
      // this.$refs.authForm.Validate()
      //获取组件内form表单值
      // console.log("authForm",this.$refs.authForm.Fields);
      const time = new Date().getTime();
      if (this.index === -1 || !this.form.id) {
        this.form.id = `role_${time}`;
        this.form.create_time = time;
      } else {
        this.form.update_time = time;
      }
      if (Number.isNaN(Number(this.form.playSpeed))) {
        this.form.playSpeed = 0.01;
      } else {
        this.form.playSpeed = Number(this.form.playSpeed);
      }
      this.$emit("handleConfirm", {
        form: this.form,
        index: this.index,
      });
    },
    cancel() {
      this.$emit("handleCancel", {});
    },
    getFormData(data) {
      // console.log("authForm",this.$refs.authForm.Fields);
      console.log("接收的数据", data);
    },
    /**
     * 改变模板配置
     */
    changeTemplate(e) {
      // 过滤掉不需要的属性
      this.form = (({ name, template }) => ({ name, template }))(this.form);
      const list = this.actionList.filter((item) => {
        return item.template_code === e;
      });
      this.config = JSON.parse(list[0].config);
      // 设置默认值
      this.$nextTick(() => {
        this.config.forEach((item) => {
          item.Fields.forEach((f) => {
            if (item.Type === "Zb") {
              this.$set(this.form, f.XCode, f.XDefaultVal);
              this.$set(this.form, f.YCode, f.YDefaultVal);
              this.$set(this.form, f.ZCode, f.ZDefaultVal);
            } else {
              this.$set(this.form, f.Code, f.DefaultVal);
            }
          });
        });
      });
    },
    /**
     * 联动
     */
    changeCascader(item, index, e) {
      if (item.Fields.length - 1 > index) {
        item.Fields[index + 1].currOptions = item.Fields[
          index + 1
        ].Options.filter((item) => {
          return item.pValue == e;
        });
      }
    },
  },
};
</script>
<style>
.window-card {
  box-shadow: 0 0px 0px 0 rgb(0 0 0 / 14%) !important;
}
</style>
